let count = 0;
const listeners = new Set();

function emit() {
  listeners.forEach((l) => l());
}

export const geocodingIndicator = {
  get count() {
    return count;
  },
  start() {
    count += 1;
    emit();
  },
  end() {
    if (count > 0) count -= 1;
    emit();
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
